import { Routing } from "helpers/routing";
import { createContext } from "react";

const TournamentDatasourceIdentifierContext = createContext<{
  params?: Routing.TournamentDatasourceIdentifiersParams
}>({})

export { TournamentDatasourceIdentifierContext}
